import BypassModal from "./BypassModal";
const DuplicateRequestPopup = ({ recentDuplicateDate, close, continueAnyway }) => {
    return (
        <BypassModal
            title="Duplicate Request Detected"
            content={<p>You already submitted a request on {recentDuplicateDate}. If you would like to revise information on the request, please email <a href="mailto:winter@dependablems.com" className="text-dependable-green hover:underline">winter@dependablems.com</a></p>}
            showVerifyCode={false}
            onClose={close}
            actions={[{
                text: "Cancel",
                onClick: close, className: "text-md md:text-lg border-4 border-gray-400 text-gray-700 px-6 py-4 transition duration-300 hover:text-white hover:bg-gray-400/80"
            }, {
                text: "Continue Anyway",
                onClick: continueAnyway, className: "text-md md:text-lg border-4 border-dependable-green px-6 py-4 transition duration-300 inline-block hover:bg-dependable-green/80 hover:text-white"
            }]}
        />
    );
};
export default DuplicateRequestPopup;